<template>
  <el-select :placeholder="placeholder" v-model="selectValue" v-if="selectOptions.length">
    <el-option v-for="option in selectOptions" :value="option.value" :label="option.label" :key="option.value" />
  </el-select>
</template>

<script>
export default {
  name: 'CascaderItem',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    leaveNum: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {
    this.initWatchers()
  },
  methods: {
    initWatchers() {
      let un = this.$watch('option.value', val => {
        this.valueChange && this.valueChange(val)
        un()
        this._parentChange()
      })
    },
    _parentChange() {
      if (this.option.parent) {
        this.$watch('option.parent.value', () => {
          this.$emit('input', '')
          this.parentChange && this.parentChange()
        })
      }
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectOptions() {
      let result = []
      let i = 0
      console.log(this.groups)
      let results = this.groups
      if (this.leaveNum !== 1) {
        if (!this.options[this.leaveNum - 2].value) return result
      }
      while (i < this.leaveNum - 1) {
        let id = this.options[i].value
        if (!id) {
          break
        }
        let find = results.find(item => item.id === id)
        if (!find) break
        results = find.nextLevelOptions || []
        i++
      }
      results.forEach(item => {
        let resultItem = {
          label: item.content,
          value: item.id
        }
        result.push(resultItem)
      })
      return result
    }
  }
}
</script>
